module.exports = __webpack_public_path__ + "static/media/43.57b0b1a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/43.jpg
// module id = 733
// module chunks = 0